const logger = require('../../utils/logger');
const NO_CONTENT_HTTP_STATUS = 204;
const getJsonHeaders = () => ({
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
    },
});
const getTextHeaders = () => ({
    headers: {
        'Content-Type': 'text/html;charset=UTF-8',
    },
});
const getFormHeaders = () => ({
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
});
const getFormData = (data) => {
    const formData = new FormData();

    for (const name in data) {
        if ({}.hasOwnProperty.call(data, name)) {
            formData.append(name, data[name]);
        }
    }

    return {body: formData};
};
const getErrorMessage = (response, data) => [
    `Request url -> ${response.url}`,
    !_.isEmpty(data) && `Payload -> ${data}`,
    `Status -> ${response.status}:${response.statusText}`,
].filter(Boolean).join(', ');
const getNoContent = (response) => response.status === NO_CONTENT_HTTP_STATUS && {};
const checkStatus = (response, {body = ''}) => {
    if (response.ok) {
        return response;
    } else {
        logger.message(getErrorMessage(response, body));
        return Promise.reject(response);
    }
};
// eslint-disable-next-line no-restricted-properties
const request = (url, params) => window.fetch(url, params)
    .then((response) => checkStatus(response, params));

class HttpRequest {
    constructor(url, httpParams = {}) {
        this.url = url;
        this.httpParams = httpParams;
    }

    defaultHeaders() {
        return request(this.url, {...this.httpParams})
            .then((response) => getNoContent(response) || response.json());
    }

    json() {
        return request(this.url, {...this.httpParams,
...getJsonHeaders()})
            .then((response) => getNoContent(response) || response.json());
    }

    text() {
        return request(this.url, {...this.httpParams,
...getTextHeaders()})
            .then((response) => getNoContent(response) || response.text());
    }

    form() {
        return request(this.url, {...this.httpParams,
...getFormHeaders(),
...getFormData(this.httpParams.body)})
            .then((response) => getNoContent(response) || response.formData());
    }

    headers(headers = {}) {
        Object.assign(this.httpParams, headers);
        return this;
    }
}

module.exports = HttpRequest;
